import { Checkbox, Dropdown, Field, NumericInput, RadioGroup, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetBalanceFieldSet, WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { AggregateSizeFraction, IntermediateSieveSize } from 'Components/Worksheets/LosAngelesValueWorksheet/types';
import { createSieveSizeCaptionGetter } from 'Data/ViewModels/Equipment/ISieveSize';
import { pipe } from 'Lib/Hooks/Selectors';
import deepEquals from 'Lib/Object/deepEquals';
import { useSelector } from 'react-redux';
import BsEnPortionDryMassSection from '../Shared/PortionDryMassSection';
import BsEnPreparationTestPortionMassSection from './PreparationTestPortionMassSection';

let BsEnPreparationSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  var aggregateSizeFractionOptions = [
    { label: '4 to 6.3', value: AggregateSizeFraction.Sizes4mmTo6_3mm },
    { label: '4 to 8', value: AggregateSizeFraction.Sizes4mmTo8mm },
    { label: '6.3 to 10', value: AggregateSizeFraction.Sizes6_3mmTo10mm },
    { label: '8 to 11.2', value: AggregateSizeFraction.Sizes8mmTo11_2mm },
    { label: '10 to 14', value: AggregateSizeFraction.Sizes10mmTo14mm },
    { label: '11.2 to 16', value: AggregateSizeFraction.Sizes11_2mmTo16mm },
    { label: '16 to 32 (Recycled Aggregate)', value: AggregateSizeFraction.Sizes16mmTo32mm },
    { label: '31.5 to 50 (Railway Ballast)', value: AggregateSizeFraction.Sizes31_5mmTo50mm },
  ];

  const sieve11_2mmCaption = useSelector(
    pipe(
      createWorksheetSelector!('data.AllSieveSizes', false),
      createSieveSizeCaptionGetter(IntermediateSieveSize.Sieve11_2mm)
    ),
    deepEquals
  );

  const sieve12_5mmCaption = useSelector(
    pipe(
      createWorksheetSelector!('data.AllSieveSizes', false),
      createSieveSizeCaptionGetter(IntermediateSieveSize.Sieve12_5mm)
    ),
    deepEquals
  );

  const intermediateSieveSizeCaption = useSelector(
    pipe(
      createWorksheetSelector!('data.AllSieveSizes', false),
      createSieveSizeCaptionGetter(useSelector(createWorksheetSelector!('Preparation.IntermediateSieveSizeId')))
    ),
    deepEquals
  );

  const intermediateSieveSizeOptions = [
    { label: sieve11_2mmCaption, value: IntermediateSieveSize.Sieve11_2mm },
    { label: sieve12_5mmCaption, value: IntermediateSieveSize.Sieve12_5mm },
  ];

  const aggregateSizeFraction = useSelector(createWorksheetSelector!('Preparation.AggregateSizeFraction'));

  return (
    <NamePrefixModifier appendNamePrefix="Preparation">
      <ListFieldSection>
        <FieldSet>
          <Field input={<Dropdown />} simpleValue name="AggregateSizeFraction" options={aggregateSizeFractionOptions} />
          <Field
            input={<Checkbox />}
            name="UseAdditionalSieve"
            visible={aggregateSizeFraction === AggregateSizeFraction.Sizes31_5mmTo50mm}
          />
        </FieldSet>
        {aggregateSizeFraction === AggregateSizeFraction.Sizes10mmTo14mm ? (
          <Field input={<RadioGroup />} name="IntermediateSieveSizeId" options={intermediateSieveSizeOptions} />
        ) : (
          <Field input={<TextOutput />} name="IntermediateSieveSizeId" value={intermediateSieveSizeCaption} />
        )}
        <WorksheetBalanceFieldSet name="Balance" />
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="oven" name="Oven" />
        <Field input={<NumericInput />} name="DryingTemperature" />
        <Field input={<NumericInput />} name="InitialSampleMass" />
      </ListFieldSection>

      <NamePrefixModifier appendNamePrefix="WashedCoarsePortion">
        <BsEnPortionDryMassSection label="Washed Coarse Portion Dry Mass" />
      </NamePrefixModifier>

      <NamePrefixModifier appendNamePrefix="WashedFinePortion">
        <BsEnPortionDryMassSection label="Washed Fine Portion Dry Mass" />
      </NamePrefixModifier>

      <BsEnPreparationTestPortionMassSection />
    </NamePrefixModifier>
  );
};

BsEnPreparationSection = withInjectedProps(BsEnPreparationSection);

export { BsEnPreparationSection };
export default BsEnPreparationSection;
